import { render } from "./Logistica.vue?vue&type=template&id=80681992"
import script from "./Logistica.vue?vue&type=script&lang=js"
export * from "./Logistica.vue?vue&type=script&lang=js"

import "./Logistica.vue?vue&type=style&index=0&id=80681992&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__